import { ar } from "./ar"
import { en } from "./en"
import { fr } from "./fr"
import { pt } from "./pt"

export type Language = "pt" | "en" | "fr" | "ar"

export interface LanguageInfo {
	code: Language
	name: string
	flag: string
}

export type Translations = typeof pt

export const availableLanguages: LanguageInfo[] = [
	{ code: "pt", name: "Português", flag: "/flags/BR.svg" },
	{ code: "en", name: "English", flag: "/flags/US.svg" },
	{ code: "fr", name: "Français", flag: "/flags/FR.svg" },
	{ code: "ar", name: "العربية", flag: "/flags/MA.svg" },
]

export const getLanguageInfo = (code: Language): LanguageInfo => {
	return availableLanguages.find((lang) => lang.code === code) || availableLanguages[0]
}

export const translations: Record<Language, Translations> = {
	pt,
	en,
	fr,
	ar,
}
